jQuery( document ).ready(function($){

    // Disable Right Click
    document.addEventListener('contextmenu', event => event.preventDefault());

    $('.cars-title').matchHeight({byRow: true, property: 'height', target: null, remove: false});
    $('.match-height').matchHeight({byRow: true, property: 'height', target: null, remove: false});

    $('.slick-cars').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        arrows: false,
        fade: false
    });

    $('.slick-cars').slick('slickPause');

    $('.slick-cars').mouseover(function() {
        $(this).slick('slickPlay');
    });
    $('.slick-cars').mouseout(function() {
        $('.slick-cars').slick('slickPause');
    });

    $('#slick').slick({
        infinite: false,
        dots: false,
        arrows: false,
        fade: true,
        autoplay: false,
        swipe: true,
        touchMove: true,
        centerMode: true,
        variableWidth: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        asNavFor: '#slick-nav'
    });

    $('#slick-nav').slick({
        infinite: false,
        dots: false,
        arrows: true,
        autoplay: false,
        slidesToShow: 6,
        slidesToScroll: 1,
        centerMode: false,
        mobileFirst: false,
        variableWidth: false,
        adaptiveHeight: false,
        asNavFor: '#slick',
        focusOnSelect: true,
        responsive: [
            {
                breakpoint: 1280,
                settings: {
                    slidesToShow: 6,
                    slidesToScroll: 1,

                }
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,

                }
            },
        ]
    });

    $('#slick').slickLightbox({
        itemSelector: 'a'
    });

    $('.gallery-left').click(function(){
        $('#slick').slick('slickPrev');
    });
    $('.gallery-right').click(function(){
        $('#slick').slick('slickNext');
    });

    $(window).resize(function(){
        $('.slick-cars').slick('refresh');
        $('#slick-nav').slick('refresh');
    });

    $('#enquire-now-btn, #enquire-now-btn-large').click(function(){
        let car = $(this).attr("data-car");
        $('.car-of-interest').find( "input" ).val(car);
    });

});